// cards/RepairQueueCard.tsx
import { useEffect, useState } from "react";
import { gxDashboardPendingRepairCountApi } from "@/app/apiConfig/services/customerAbstractApiLayer";
import SubmitLoading from "@/app/components/webloading/errorHandling/SubmitLoading";

interface DashboardCardProps {
  title: string;
}

const RepairQueueCard = ({ title }: DashboardCardProps) => {
  const [total, setTotal] = useState<number>(0);
  const [loading, setLoading] = useState<boolean>(true);

  useEffect(() => {
    let isMounted = true;

    const fetchRepairCount = async () => {
      setLoading(true);
      try {
        const result = await gxDashboardPendingRepairCountApi({});
        if (isMounted) {
          setTotal(result?.data?.countOfRepair ?? 0);
        }
      } catch (error) {
        console.error("RepairQueueCard: failed to load repair count", error);
        if (isMounted) setTotal(0);
      } finally {
        if (isMounted) setLoading(false);
      }
    };

    fetchRepairCount();

    return () => {
      isMounted = false;
    };
  }, []);

  return (
    <div className="gx-alter-card relative">
      {loading && (
        <div className="gx-bene-form-container-loading-overlay">
          <SubmitLoading />
        </div>
      )}
      <h3 className="gx-alter-approval-header-text gx-p16-sb">{title}</h3>
      <span className="gx-alter-approval-text-value gx-36-sb">{total}</span>
      <p className="alter-approval-policy-text_red gx-p14-b">Consent Pending</p>
    </div>
  );
};

export default RepairQueueCard;
